var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.home()}}},[_c('i',{staticClass:"fas fa-home me-2"}),_vm._v("Home")])
}
var staticRenderFns = []

export { render, staticRenderFns }